import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useCallback } from 'react'

import { MarketplaceDataPage } from '@/components/DataVault/MarketplaceDataPage'
import {
  marketplaceDataSearchSchema,
  type MarketplaceDataSearch,
} from '@/components/DataVault/marketplaceData'

/** Wiring only. The schema lives beside the page. */
export const Route = createFileRoute('/_app/data-vault/marketplace-data')({
  validateSearch: marketplaceDataSearchSchema,
  component: MarketplaceDataRoute,
})

function MarketplaceDataRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })
  const onSearchChange = useCallback(
    (next: Partial<MarketplaceDataSearch>) =>
      void navigate({ search: (current) => ({ ...current, ...next }), replace: true }),
    [navigate],
  )
  return <MarketplaceDataPage search={search} onSearchChange={onSearchChange} />
}
